import {
  customScrollMinimal,
  Icon,
  TableCell,
  TanStackTableRoot,
} from '@toggle/design-system';
import { PriceStatus } from '@toggle/helpers';
import styled, { css } from 'styled-components';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { priceChangeColors } from '~/utils/common/utils';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  ${customScrollMinimal};
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

export const StyledTanStackTableRoot = styled(TanStackTableRoot)<{
  $isWatchlistPage: boolean;
}>`
  ${({ $isWatchlistPage }) =>
    !$isWatchlistPage &&
    css`
      table-layout: fixed;
    `}
`;

export const TickerCell = styled.div`
  display: flex;
  gap: 8px;
`;

export const Ticker = styled.div<{ $isWatchlistPage?: boolean }>`
  ${({ $isWatchlistPage }) =>
    $isWatchlistPage
      ? css`
          flex: 1;
          display: flex;
          align-items: center;
        `
      : css`
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `}
`;

export const Name = styled.div<{ $isWatchlistPage?: boolean }>`
  ${({ $isWatchlistPage }) =>
    !$isWatchlistPage &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;

export const HighlightText = styled.span`
  color: var(--text-soft);

  b {
    font-family: var(--font-roboto-mono);
    color: var(--text-default);
  }
`;

export const StyledAssetLogoContainer = styled(AssetLogoContainer)`
  border-radius: 50%;
`;

export const PriceWrapper = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  gap: 4px;

  color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--text-disabled)' : 'var(--text-default)'};
`;

export const Currency = styled.span`
  font-size: 8px;
  text-transform: uppercase;
  margin-top: 2px;
`;

export const StampWrapper = styled.div<{
  $color: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  width: 20px;
  > svg {
    fill: ${({ $color }) => $color};
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: end;
`;

export const ValueWrapper = styled.div<{
  $status: PriceStatus;
  $alignment?: string;
}>`
  color: ${({ $status }) => priceChangeColors[$status]};
`;

export const TableHeaderEditMode = styled.span`
  display: flex;
`;

export const StyledGripsDots = styled(Icon)`
  margin: 4px;
`;

export const GripsWrapper = styled.span`
  padding: 0 4px;
  cursor: grab;
`;

export const CheckboxWrapper = styled.span`
  padding-left: 20px;
`;

export const CellFlexWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const StyledTableCell = styled(TableCell)<{
  $noPadding?: boolean;
}>`
  ${({ $noPadding }) =>
    $noPadding &&
    css`
      padding: 0px;
    `}
`;

export const StyledCol = styled.col<{ $percentageWidth: string }>`
  ${({ $percentageWidth }) =>
    css`
      width: ${$percentageWidth};
    `}
`;
